import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-mrva-dashboard-dw",
  templateUrl: "./mrva-dashboard-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MrvaDashboardDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.MRVA_DASHBOARD;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID,
                           HideFilters.PROJECT_NAME2, HideFilters.CUSTOMER_NAME, HideFilters.ORGANIZATION_NAME];
}
